<template>
  <div>
    <v-form v-if="loginFormVisible" class="px-3" ref="form">
      <v-text-field 
        id="email"
        label="Email"
        prepend-icon="email"
        v-model="email"
        :rules="[inputRules.required, inputRules.email]">
      </v-text-field>
      <v-text-field
        id="password"
        label="Password"
        :type="showPassword ? 'text' : 'password'"
        prepend-icon="lock"
        :append-icon="showPassword ? 'mdi-eye' : 'mdi-eye-off'"
        v-model="password"
        :rules="[inputRules.required]"
        @click:append="showPassword = !showPassword"
        @keydown.enter="login">
      </v-text-field>
      <v-spacer></v-spacer>
      <v-alert v-if="errorMessage" type="error">{{ errorMessage }}</v-alert>

      <v-row>
        <v-col class="text-right pt-3">
          <v-btn text @click="showResetForm()">
            Forgot password?
          </v-btn>
          <v-btn id="email-login" depressed class="primary ml-5" @click="login" :loading="submitting">
            Login
          </v-btn>
        </v-col>
      </v-row>
    </v-form>


    <v-form v-else class="px-3" ref="resetForm">
      <v-text-field 
        id="email"
        label="Email"
        prepend-icon="email"
        v-model="email"
        :rules="[inputRules.required, inputRules.email]">
      </v-text-field>

      <v-spacer></v-spacer>
      <v-alert v-if="errorMessage" type="error">{{ errorMessage }}</v-alert>


      <v-row>
        <v-col class="text-right pt-3">
          <v-btn text @click="showLoginForm()">
            Back to login
          </v-btn>
          <v-btn id="email-login" depressed class="primary ml-5" @click="sendResetEmail" :loading="submitting">
            Send reset instructions
          </v-btn>
        </v-col>
      </v-row>

    </v-form>
  </div>
</template>


<script>
import firebase from '@/firebase.config'
import { initialiseUser } from './common'

export default {
  name: 'Login',
  props: ['redirectRouteName', 'userType'],
  data() {
    return {
      email: '',
      password: '',
      showPassword: false,
      loginFormVisible: true,
      submitting: false,
      errorMessage: '',
      inputRules: {
        required: value => !!value || 'Required',
        email: v => /.+@.+/.test(v) || 'Email must be valid'
      }
    }
  },
  methods: {
    showLoginForm() {
      this.loginFormVisible = true
      this.errorMessage = ''
    },
    showResetForm() {
      this.loginFormVisible = false
      this.errorMessage = ''
    },
    async login() {
      if (this.$refs.form.validate()) {
        // Set submitting to true, triggering spinner on Submit button
        this.submitting = true

        try {
          const cred = await firebase.auth().signInWithEmailAndPassword(this.email, this.password)
          await initialiseUser(cred, 'EMAIL', this.userType)
          
          this.submitting = false
          this.$store.dispatch('hideDialog')
          this.$store.dispatch('storeSnackbarMessage', 'Welcome back! You have logged in')
          if (this.redirectRouteName){
            this.$router.push({ name: this.redirectRouteName})
          }
        } catch(err) {
          // Remove spinner from the Submit button
          this.submitting = false
          // Add a nice message if the email address is not found
          if (err.code === 'auth/user-not-found') {
            this.errorMessage = 'There is no account with this email address'
          }
          else if (err.code === 'auth/wrong-password') {
            this.errorMessage = 'Incorrect password'
          }
          else {
            this.errorMessage = err.message
          }
        }
      }
    },
    async sendResetEmail() {
      if (this.$refs.resetForm.validate()) {
        // Set submitting to true, triggering spinner on Submit button
        this.submitting = true

        try {
          await firebase.auth().sendPasswordResetEmail(this.email)
          this.$store.dispatch('storeSnackbarMessage', 'Check your email for instructions to reset your password')
        } catch(err) {
          // Add a nice message if the email address is not found
          if (err.code === 'auth/user-not-found') {
            this.errorMessage = 'There is no account with this email address'
          }
          else {
            this.errorMessage = err.message
          }
        }
        this.submitting = false
      }
    }

  }
}
</script>